module.exports = __webpack_public_path__ + "static/media/prefcardsHome.104f00b4.png";